import { useCallback, useEffect, useMemo, useState } from 'react';
import { RequestStatuses } from 'content-management-data-lib';
import { fetchContentObject, fetchContentObjectByAnalyticsPageId } from '../api/Content';
const useContentObject = ({
  contentId,
  contentObjectType,
  providedContentObject,
  contentTypeHasLegacyAnalyticsPages
}) => {
  const [contentObject, setContentObject] = useState(null);
  const [requestStatus, setRequestStatus] = useState(providedContentObject ? RequestStatuses.SUCCEEDED : RequestStatuses.UNINITIALIZED);
  const [requestErrorData, setRequestErrorData] = useState({
    category: '',
    subCategory: '',
    statusCode: 0
  });
  const handleError = err => {
    var _err$responseJSON, _err$responseJSON2;
    const category = ((_err$responseJSON = err.responseJSON) === null || _err$responseJSON === void 0 ? void 0 : _err$responseJSON.category) || '';
    const subCategory = ((_err$responseJSON2 = err.responseJSON) === null || _err$responseJSON2 === void 0 ? void 0 : _err$responseJSON2.subCategory) || '';
    setRequestStatus(RequestStatuses.FAILED);
    setRequestErrorData({
      category,
      subCategory,
      statusCode: err.status
    });
  };
  const fetchRequest = useCallback(() => {
    if (providedContentObject) {
      setContentObject(providedContentObject);
      return;
    }
    setRequestStatus(RequestStatuses.PENDING);
    fetchContentObject(contentObjectType, contentId).then(contentCrmObject => {
      setContentObject(contentCrmObject);
      setRequestStatus(RequestStatuses.SUCCEEDED);
    }).catch(e => {
      if (contentTypeHasLegacyAnalyticsPages) {
        fetchContentObjectByAnalyticsPageId(contentObjectType, contentId).then(contentCrmObject => {
          setContentObject(contentCrmObject);
          setRequestStatus(RequestStatuses.SUCCEEDED);
        }).catch(fetchByAnalyticsPageIdError => {
          handleError(fetchByAnalyticsPageIdError);
        });
      } else {
        handleError(e);
      }
    });
  }, [contentId, contentObjectType, providedContentObject, contentTypeHasLegacyAnalyticsPages]);
  useEffect(() => {
    fetchRequest();
  }, [fetchRequest]);
  return useMemo(() => ({
    contentObject,
    fetchContentObjectRequestStatus: requestStatus,
    contentObjectRequestErrorData: requestErrorData,
    setContentObject
  }), [requestStatus, contentObject, requestErrorData, setContentObject]);
};
export default useContentObject;